import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export enum AccountDistributionStrategyIdDTO {
  OrionDefault,
  Custom,
  Inherit,
}

export type AccountDistributionOrderItemIdDTO = string;

export type CurrentDistributionOrderDTO = {
  preRetirement: AccountDistributionOrderItemIdDTO[];
  postRetirement: AccountDistributionOrderItemIdDTO[] | null;
};

export type AccountDistributionOrderOptionDTO = {
  id: AccountDistributionOrderItemIdDTO;
  label: string;
  taxStatus: string;
};

export interface AccountDistributionOrderDTO {
  options: AccountDistributionOrderOptionDTO[];
  default: AccountDistributionOrderItemIdDTO[];
}

const fetchAccountDistributionOrder = async (
  clientId?: number,
): Promise<AccountDistributionOrderDTO> =>
  authFetch(urlWithParams('/Adviser/AccountDistributionOrder', { clientId }));

export const useAccountDistributionOrderQuery = (clientId?: number) =>
  useQuery(
    queryKeys.accountDistributionOrder(clientId),
    () => fetchAccountDistributionOrder(clientId),
    { cacheTime: 0 },
  );
